import { useEffect, useRef, useCallback } from 'react';
import { io } from 'socket.io-client';

let globalSocket = null;

export function useSocket() {
  const initialized = useRef(false);

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      const token = localStorage.getItem('tp_token');
      if (!token) return;
      if (!globalSocket) {
        globalSocket = io(process.env.REACT_APP_API_URL || 'http://localhost:3001', {
          auth: { token },
          transports: ['websocket','polling'],
          reconnection: true,
          reconnectionDelay: 2000,
        });
        globalSocket.on('connect', () => console.log('[WS] Connected'));
        globalSocket.on('disconnect', () => console.log('[WS] Disconnected'));
        globalSocket.on('connect_error', (e) => console.warn('[WS] Error:', e.message));
      }
    }
    return () => {};
  }, []);

  const on = useCallback((event, handler) => {
    if (!globalSocket) return () => {};
    globalSocket.on(event, handler);
    return () => globalSocket.off(event, handler);
  }, []);

  const emit = useCallback((event, data) => {
    if (globalSocket?.connected) globalSocket.emit(event, data);
  }, []);

  return { on, emit, socket: globalSocket };
}
